export default "__VITE_ASSET__636d3662__"